import { render } from "./SystemVersionRecordList.vue?vue&type=template&id=7cebd133&scoped=true"
import script from "./SystemVersionRecordList.vue?vue&type=script&lang=js"
export * from "./SystemVersionRecordList.vue?vue&type=script&lang=js"

import "./SystemVersionRecordList.vue?vue&type=style&index=0&id=7cebd133&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cebd133"]])

export default __exports__